class CartDrawer extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    this.addDirectEvent("addtocart", document, () => {
      this.render().then(() => this.show());
    });

    this.addDirectEvent("cartlink:click", document, () => {
      this.show();
    });

    if (Theme.URLParams.has("cart")) {
      this.show();
    }
  }

  show() {
    document.dispatchEvent(new CustomEvent("cartdrawer:show"));

    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
  }

  guard(task) {
    if (this.pending) {
      return Promise.resolve();
    }

    this.pending = true;
    this.classList.add("state--pending");
    this.setAttribute("aria-busy", "true");

    return Promise.resolve()
      .then(task)
      .finally(() => {
        this.pending = false;
        this.classList.remove("state--pending");
        this.removeAttribute("aria-busy");
      });
  }

  changeSubscription(item, element) {
    return this.guard(() => this.updateLine({
      id: item.key,
      quantity: item.quantity,
      selling_plan: element.value
    }));
  }

  changeIntoSubscription(item) {
    return this.guard(() => fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify({ items: [item] })
    })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => Promise.reject(error));
      }

      return this.updateLine({ id: item.key, quantity: 0 });
    })
    .catch((error) => {
      console.error("CartDrawer: subscribe failed", error);
    }));
  }

  change(data, element) {
    return this.guard(() => this.updateLine(data, element));
  }

  updateLine(data, element) {
    const container = element ? element.closest(".spinner-container") : null;

    if (container) {
      container.classList.add("state--loading");
    }

    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(Object.assign({ sections: "cart-drawer" }, data))
    })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => Promise.reject(error));
      }

      return response.json();
    })
    .then((cart) => {
      const sections = cart.sections;

      delete cart.sections;

      document.dispatchEvent(new CustomEvent("cart:change", {
        detail: cart
      }));

      return this.render(sections);
    })
    .catch((error) => {
      if (container) {
        container.classList.remove("state--loading");
      }

      console.error("CartDrawer: change failed", error);
    });
  }

  render(sections) {
    function get_new_content(markup) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(markup, "text/html");

      return doc.getElementById("cart");
    }

    const markup = sections && sections["cart-drawer"]
      ? Promise.resolve(sections["cart-drawer"])
      : fetch("/?sections=cart-drawer")
        .then((response) => response.json())
        .then((response) => response["cart-drawer"]);

    return markup
      .then((string) => {
        document.getElementById("cart").replaceWith(get_new_content(string));
      })
      .then(() => this.resetActionEvents());
  }
}

customElements.define("cart-drawer", CartDrawer);
